import React from 'react';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { StyledEngineProvider } from '@mui/material/styles';
import './assets/styles/styles.scss';
import { GoogleOAuthProvider } from "@react-oauth/google";

// App Routes
import { routes } from "./routes";

const App = ({ store }) => {


	return (
		<GoogleOAuthProvider clientId="464640122635-5rpec2q21v3baih8gtvghta19aqfivs5.apps.googleusercontent.com">
			<Provider store={store}>
				<StyledEngineProvider injectFirst>
					<BrowserRouter children={routes} basename={"/"} />
				</StyledEngineProvider>
			</Provider>
		</GoogleOAuthProvider>
	);

};

App.propTypes = {
	store: PropTypes.object.isRequired
};

export default App;